import { useCallback, useEffect, useMemo, useState } from 'react';
import { NewUserInput, User } from '../types/user';

const STORAGE_KEY = 'admin_users_v2';

const seedUsers: User[] = [
  {
    id: 'u_1',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@company.com',
    role: 'Admin',
    status: 'Active',
    createdAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1001',
    department: 'Engineering',
    position: 'Tech Lead',
    location: 'New York',
    avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
  },
  {
    id: 'u_2',
    firstName: 'Jane',
    lastName: 'Smith',
    email: 'jane.smith@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1002',
    department: 'Marketing',
    position: 'Manager',
    location: 'San Francisco',
    avatarUrl: 'https://randomuser.me/api/portraits/women/44.jpg',
  },
  {
    id: 'u_3',
    firstName: 'Mike',
    lastName: 'Johnson',
    email: 'mike.johnson@company.com',
    role: 'User',
    status: 'Inactive',
    createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1003',
    department: 'Support',
    position: 'Agent',
    location: 'Remote',
    avatarUrl: 'https://randomuser.me/api/portraits/men/45.jpg',
  },
  {
    id: 'u_4',
    firstName: 'Emily',
    lastName: 'Wilson',
    email: 'emily.wilson@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1004',
    department: 'Design',
    position: 'Product Designer',
    location: 'Austin',
    avatarUrl: 'https://randomuser.me/api/portraits/women/46.jpg',
  },
  {
    id: 'u_5',
    firstName: 'David',
    lastName: 'Brown',
    email: 'david.brown@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 7 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1005',
    department: 'Sales',
    position: 'Account Exec',
    location: 'Chicago',
    avatarUrl: 'https://randomuser.me/api/portraits/men/47.jpg',
  },
  {
    id: 'u_6',
    firstName: 'Lisa',
    lastName: 'Anderson',
    email: 'lisa.anderson@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1006',
    department: 'People Ops',
    position: 'HR Generalist',
    location: 'Seattle',
    avatarUrl: 'https://randomuser.me/api/portraits/women/48.jpg',
  },
  {
    id: 'u_7',
    firstName: 'Alex',
    lastName: 'Thompson',
    email: 'alex.thompson@company.com',
    role: 'User',
    status: 'Inactive',
    createdAt: new Date(Date.now() - 100 * 24 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1007',
    department: 'Finance',
    position: 'Analyst',
    location: 'Toronto',
    avatarUrl: 'https://randomuser.me/api/portraits/men/49.jpg',
  },
  {
    id: 'u_8',
    firstName: 'Maria',
    lastName: 'Garcia',
    email: 'maria.garcia@company.com',
    role: 'Admin',
    status: 'Active',
    createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1008',
    department: 'Operations',
    position: 'Ops Lead',
    location: 'Miami',
    avatarUrl: 'https://randomuser.me/api/portraits/women/50.jpg',
  },
  {
    id: 'u_9',
    firstName: 'Noah',
    lastName: 'Miller',
    email: 'noah.miller@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 10 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1009',
    department: 'Engineering',
    position: 'Frontend Dev',
    location: 'Remote',
    avatarUrl: 'https://randomuser.me/api/portraits/men/51.jpg',
  },
  {
    id: 'u_10',
    firstName: 'Olivia',
    lastName: 'Davis',
    email: 'olivia.davis@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 90 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1010',
    department: 'Engineering',
    position: 'Backend Dev',
    location: 'Denver',
    avatarUrl: 'https://randomuser.me/api/portraits/women/51.jpg',
  },
  {
    id: 'u_11',
    firstName: 'Liam',
    lastName: 'Martinez',
    email: 'liam.martinez@company.com',
    role: 'User',
    status: 'Inactive',
    createdAt: new Date(Date.now() - 200 * 24 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1011',
    department: 'Legal',
    position: 'Counsel',
    location: 'Boston',
    avatarUrl: 'https://randomuser.me/api/portraits/men/52.jpg',
  },
  {
    id: 'u_12',
    firstName: 'Sophia',
    lastName: 'Lopez',
    email: 'sophia.lopez@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1012',
    department: 'Customer Success',
    position: 'CSM',
    location: 'London',
    avatarUrl: 'https://randomuser.me/api/portraits/women/52.jpg',
  },
  {
    id: 'u_13',
    firstName: 'Mason',
    lastName: 'Clark',
    email: 'mason.clark@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1013',
    department: 'IT',
    position: 'Sysadmin',
    location: 'Dublin',
    avatarUrl: 'https://randomuser.me/api/portraits/men/53.jpg',
  },
  {
    id: 'u_14',
    firstName: 'Ava',
    lastName: 'Hernandez',
    email: 'ava.hernandez@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    lastLoginAt: new Date(Date.now() - 50 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1014',
    department: 'Design',
    position: 'UX Researcher',
    location: 'Berlin',
    avatarUrl: 'https://randomuser.me/api/portraits/women/53.jpg',
  },
  {
    id: 'u_15',
    firstName: 'Ethan',
    lastName: 'Rodriguez',
    email: 'ethan.rodriguez@company.com',
    role: 'User',
    status: 'Active',
    createdAt: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString(),
    phoneNumber: '+1 (555) 010-1015',
    department: 'Product',
    position: 'PM',
    location: 'Madrid',
    avatarUrl: 'https://randomuser.me/api/portraits/men/54.jpg',
  },
];

function loadUsers(): User[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(seedUsers));
      return seedUsers;
    }
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.length > 0) {
      return parsed;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(seedUsers));
    return seedUsers;
  } catch (e) {
    console.error('Failed to load users from storage', e);
    return seedUsers;
  }
}

function saveUsers(users: User[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(users));
  } catch (e) {
    console.error('Failed to save users to storage', e);
  }
}

function generateId() {
  return 'u_' + Math.random().toString(36).slice(2, 10);
}

export interface UseUsersResult {
  users: User[];
  loading: boolean;
  error: string | null;
  search: string;
  setSearch: (s: string) => void;
  selectedRoles: ('Admin' | 'User')[];
  toggleRoleFilter: (role: 'Admin' | 'User') => void;
  availableDepartments: string[];
  availableLocations: string[];
  selectedDepartments: string[];
  selectedLocations: string[];
  toggleDepartmentFilter: (dept: string) => void;
  toggleLocationFilter: (loc: string) => void;
  page: number;
  setPage: (n: number) => void;
  pageSize: number;
  setPageSize: (n: number) => void;
  total: number;
  pagedUsers: User[];
  addUser: (input: NewUserInput) => Promise<User>;
  deleteUsers: (ids: string[]) => Promise<void>;
  bulkAddCsv: (csvText: string) => Promise<{ created: number; errors: number; }>; 
  updateUser: (id: string, updates: Partial<User>) => Promise<User>;
  changePassword: (id: string, newPassword: string) => Promise<void>;
  resetUsers: () => Promise<void>;
  refresh: () => void;
}

export function useUsers(): UseUsersResult {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRoles, setSelectedRoles] = useState<("Admin" | "User")[]>(["Admin", "User"]);
  const [selectedDepartments, setSelectedDepartments] = useState<string[]>([]);
  const [selectedLocations, setSelectedLocations] = useState<string[]>([]);

  const toggleRoleFilter = useCallback((role: "Admin" | "User") => {
    setSelectedRoles(prev => (
      prev.includes(role)
        ? prev.filter(r => r !== role)
        : [...prev, role]
    ));
    setPage(1);
  }, []);

  const toggleDepartmentFilter = useCallback((dept: string) => {
    setSelectedDepartments(prev => (
      prev.includes(dept)
        ? prev.filter(d => d !== dept)
        : [...prev, dept]
    ));
    setPage(1);
  }, []);

  const toggleLocationFilter = useCallback((loc: string) => {
    setSelectedLocations(prev => (
      prev.includes(loc)
        ? prev.filter(l => l !== loc)
        : [...prev, loc]
    ));
    setPage(1);
  }, []);

  // initial load
  useEffect(() => {
    setLoading(true);
    try {
      const data = loadUsers();
      setUsers(data);
      setError(null);
    } catch (e) {
      setError('Failed to load users');
    } finally {
      setLoading(false);
    }
  }, []);

  const availableDepartments = useMemo(() => {
    const set = new Set<string>();
    users.forEach(u => { if (u.department) set.add(u.department); });
    return Array.from(set).sort((a,b) => a.localeCompare(b));
  }, [users]);

  const availableLocations = useMemo(() => {
    const set = new Set<string>();
    users.forEach(u => { if (u.location) set.add(u.location); });
    return Array.from(set).sort((a,b) => a.localeCompare(b));
  }, [users]);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    let base = users;
    // Role filter
    base = base.filter(u => selectedRoles.includes(u.role));
    // Department filter
    if (selectedDepartments.length > 0) {
      base = base.filter(u => selectedDepartments.includes(u.department || ''));
    }
    // Location filter
    if (selectedLocations.length > 0) {
      base = base.filter(u => selectedLocations.includes(u.location || ''));
    }
    if (!term) return base;
    return base.filter(u =>
      u.firstName.toLowerCase().includes(term) ||
      u.lastName.toLowerCase().includes(term) ||
      u.email.toLowerCase().includes(term) ||
      (u.role?.toLowerCase?.() || '').includes(term) ||
      (u.status?.toLowerCase?.() || '').includes(term) ||
      (u.department?.toLowerCase?.() || '').includes(term) ||
      (u.position?.toLowerCase?.() || '').includes(term) ||
      (u.location?.toLowerCase?.() || '').includes(term)
    );
  }, [users, search, selectedRoles, selectedDepartments, selectedLocations]);

  const total = filtered.length;
  const pagedUsers = useMemo(() => {
    const start = (page - 1) * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, page, pageSize]);

  const addUser = useCallback(async (input: NewUserInput): Promise<User> => {
    const newUser: User = {
      id: generateId(),
      firstName: input.firstName,
      lastName: input.lastName,
      email: input.email,
      role: input.role,
      status: input.status,
      createdAt: new Date().toISOString(),
      phoneNumber: input.phoneNumber,
      department: input.department,
      position: input.position,
      location: input.location,
      avatarUrl: input.avatarUrl,
    };
    const next = [newUser, ...users];
    setUsers(next);
    saveUsers(next);
    return newUser;
  }, [users]);

  const deleteUsers = useCallback(async (ids: string[]): Promise<void> => {
    const idSet = new Set(ids);
    const next = users.filter(u => !idSet.has(u.id));
    setUsers(next);
    saveUsers(next);
  }, [users]);

  const bulkAddCsv = useCallback(async (csvText: string): Promise<{ created: number; errors: number; }> => {
    // Expected headers: firstName,lastName,email,role,status
    const lines = csvText.split(/\r?\n/).filter(l => l.trim().length > 0);
    if (lines.length === 0) return { created: 0, errors: 0 };

    let created = 0;
    let errors = 0;
    const header = lines[0].split(',').map(h => h.trim().toLowerCase());
    const hasHeader = ['firstname','lastname','email','role','status'].every(h => header.includes(h));
    const startIdx = hasHeader ? 1 : 0;

    const next = [...users];
    for (let i = startIdx; i < lines.length; i++) {
      const cols = lines[i].split(',').map(c => c.trim());
      const [firstName, lastName, email, role, status] = hasHeader
        ? [
            cols[header.indexOf('firstname')],
            cols[header.indexOf('lastname')],
            cols[header.indexOf('email')],
            cols[header.indexOf('role')],
            cols[header.indexOf('status')],
          ]
        : cols;

      if (!firstName || !lastName || !email) {
        errors++;
        continue;
      }
      const roleNorm = (role || 'User').toLowerCase();
      const statusNorm = (status || 'Active').toLowerCase();
      if (!['admin','user'].includes(roleNorm) || !['active','inactive'].includes(statusNorm)) {
        errors++;
        continue;
      }

      const newUser: User = {
        id: generateId(),
        firstName,
        lastName,
        email,
        role: roleNorm === 'admin' ? 'Admin' : 'User',
        status: statusNorm === 'active' ? 'Active' : 'Inactive',
        createdAt: new Date().toISOString(),
      };
      next.unshift(newUser);
      created++;
    }

    setUsers(next);
    saveUsers(next);
    return { created, errors };
  }, [users]);

  const updateUser = useCallback(async (id: string, updates: Partial<User>): Promise<User> => {
    const idx = users.findIndex(u => u.id === id);
    if (idx === -1) throw new Error('User not found');
    const updated: User = { ...users[idx], ...updates };
    const next = [...users];
    next[idx] = updated;
    setUsers(next);
    saveUsers(next);
    return updated;
  }, [users]);

  const changePassword = useCallback(async (id: string, newPassword: string): Promise<void> => {
    // Simulate async password change. In a real app, call the API here.
    const exists = users.some(u => u.id === id);
    if (!exists) throw new Error('User not found');
    await new Promise(r => setTimeout(r, 500));
  }, [users]);

  const refresh = useCallback(() => {
    const latest = loadUsers();
    setUsers(latest);
  }, []);

  const resetUsers = useCallback(async (): Promise<void> => {
    setUsers(seedUsers);
    saveUsers(seedUsers);
  }, []);

  return {
    users,
    loading,
    error,
    search,
    setSearch,
    page,
    setPage,
    pageSize,
    setPageSize,
    total,
    pagedUsers,
    addUser,
    deleteUsers,
    bulkAddCsv,
    updateUser,
    changePassword,
    resetUsers,
    selectedRoles,
    toggleRoleFilter,
    availableDepartments,
    availableLocations,
    selectedDepartments,
    selectedLocations,
    toggleDepartmentFilter,
    toggleLocationFilter,
    refresh,
  };
} 